import React from "react";

const UNKNOWN = "__unknown__";
export const creatorKey = (s) => (s.created_by_user_id ? String(s.created_by_user_id) : UNKNOWN);

// Unique creators (with scenario counts); the viewer is always listed as "My scenarios".
export function listCreators(scenarios, viewerId) {
  const seen = new Map();
  for (const s of scenarios || []) {
    const k = creatorKey(s);
    if (k === viewerId) continue;
    const prev = seen.get(k);
    if (prev) prev.count += 1;
    else seen.set(k, { id: k, name: k === UNKNOWN ? "Unknown" : s.user_name || "Unknown", count: 1 });
  }
  return [...seen.values()].sort((a, b) => a.name.localeCompare(b.name));
}

function Box({ checked, onChange, label, testId, bold }) {
  return (
    <label className="flex items-center gap-1.5 cursor-pointer whitespace-nowrap" data-testid={testId}>
      <input type="checkbox" checked={checked} onChange={onChange} className="accent-[#1C4E80] w-[15px] h-[15px]" />
      <span className={bold ? "font-semibold" : ""}>{label}</span>
    </label>
  );
}

export function ScenarioCreatorFilter({ creators, viewerId, selected, onChange, myCount = 0 }) {
  const allIds = [viewerId, ...creators.map((c) => c.id)];
  const allOn = allIds.every((id) => selected.has(id));
  const toggle = (id) => {
    const next = new Set(selected);
    next.has(id) ? next.delete(id) : next.add(id);
    onChange(next);
  };
  return (
    <div className="flex items-center flex-wrap gap-x-4 gap-y-1 text-[14px]" style={{ color: "#0F2A44" }} data-testid="scenario-creator-filter">
      <span className="font-semibold">Show:</span>
      <Box checked={allOn} onChange={() => onChange(new Set(allOn ? [] : allIds))} label="All" testId="scenario-filter-all" bold />
      <Box checked={selected.has(viewerId)} onChange={() => toggle(viewerId)} label={`My Scenarios (${myCount})`} testId="scenario-filter-mine" />
      {creators.map((c) => (
        <Box key={c.id} checked={selected.has(c.id)} onChange={() => toggle(c.id)} label={`${c.name} (${c.count})`} testId={`scenario-filter-creator-${c.id}`} />
      ))}
    </div>
  );
}
